import { Params } from '@angular/router';

/**
 * Associates a translated, permission-managed route (NavKeys) with dynamic data, like query params.
 */

export class NavItem {
  public constructor(
    public key: string,
    public disable: boolean,
    public queryParams?: Params,
    public disabledKeyTooltip?: string,
    public customNavMethod?: any,
    public titleKey?: string
  ) {}
}
